const TAINT_ANALYSIS_KEYWORD = 'Taint Analysis';

export function isTaintAnalysisRule(ruleName: string | undefined): boolean {
  return ruleName?.includes(TAINT_ANALYSIS_KEYWORD) ?? false;
}

export const findingAttackToDisplayName: Record<string, string> = {
  /* Reconnaissance */
  ['T_2_1']: 'Reconnaissance_T2',
  ['T_2_1_1']: 'search_open_sources_T2-1-1',
  ['T_2_1_2']: 'active_scanning_T2-1-2',
  ['T_2_1_3']: 'search_closed_sources_T2-1-3',
  ['T_2_1_4']: 'finding_rag_indexed_targets_T2-1-4',

  /* Resource Development */
  ['T_2_2']: 'resource_development_T2-2',
  ['T_2_2_1']: 'commercial_license_abuse_T2-2-1',
  ['T_2_2_2']: 'prompt_crafting_T2-2-2',
  ['T_2_2_3']: 'prompt_stabilizing_T2-2-3',

  /* Initial Access */
  ['T_2_3']: 'initial_access_T2-3',
  ['T_2_3_1']: 'rag_poisoning_T2-3-1',
  ['T_2_3_2']: 'retrieval_tool_poisoning_T2-3-2',
  ['T_2_3_3']: 'targeted_rag_poisoning_T2-3-3',
  ['T_2_3_4']: 'compromised_user_T2-3-4',
  ['T_2_3_5']: 'web_poisoning_T2-3-5',
  ['T_2_3_6']: 'guest_user_abuse_T2-3-6',
  ['T_2_3_7']: 'user_manipulation_T2-3-7',

  /* Execution */
  ['T_2_4']: 'execution_T2-4',
  ['T_2_4_1']: 'prompt_injection_T2-4-1',
  ['T_2_4_2']: 'off_target_language_T2-4-2',
  ['T_2_4_3']: 'system_instruction_keywords_T2-4-3',

  /* Persistence */
  ['T_2_5']: 'persistence_T2-5',
  ['T_2_5_1']: 'resource_poisoning_T2-5-1',
  ['T_2_5_2']: 'thread_infection_T2-5-2',
  ['T_2_5_3']: 'memory_infection_T2-5-3',

  /* Privilege Escalation */
  ['T_2-6']: 'privilege_escalation_T2-6',
  ['T_2_6_1']: 'jailbreaking_T2-6-1',
  ['T_2_6_2']: 'crescendo_T2-6-2',
  ['T_2_6_3']: 'off_target_language_T2-6-3',
  ['T_2_6_4']: 'system_instruction_keywords_T2-6-4',

  /* Defense Evasion */
  ['T_2_7']: 'defense_evasion_T2-7',
  ['T_2_7_1']: 'indirect_data_access_T2-7-1',
  ['T_2_7_2']: 'distraction_T2-7-2',
  ['T_2_7_3']: 'citation_silencing_T2-7-3',
  ['T_2_7_4']: 'blank_image_T2-7-4',
  ['T_2_7_5']: 'conditional_execution_T2-7-5',
  ['T_2_7_6']: 'URL_familiarizing_T2-7-6',
  ['T_2_7_7']: 'delayed_execution_T2-7-7',
  ['T_2_7_8']: 'ascii_smuggling_T2-7-8',
  ['T_2_7_9']: 'rag_injection_T2-7-9',
  ['T_2_7_10']: 'these_are_not_the_droids_T2-7-10',

  /* Credential Access */
  ['T_2_8']: 'credential_access_T2-8',
  ['T_2_8_1']: 'retrieval_tool_credential_harvesting_T2-8-1',
  ['T_2_8_2']: 'rag_credential_harvesting_T2-8-2',

  /* Discovery */
  ['T_2_9']: 'discovery_T2-9',
  ['T_2_9_1']: 'delimiters_and_special_character_extraction_T2-9-1',
  ['T_2_9_2']: 'who_am_i_T2-9-2',
  ['T_2_9_3']: 'failure_mode_mapping_T2-9-3',
  ['T_2_9_4']: 'embedded_knowledge_exposure_T2-9-4',
  ['T_2_9_5']: 'system_instructions_extraction_T2-9-5',
  ['T_2_9_6']: 'tool_definition_discovery_T2-9-6',

  /* Lateral Movement */
  ['T_2_10']: 'lateral_movement_T2-10',
  ['T_2_10_1']: 'shared_resource_poisoning_T2-10-1',
  ['T_2_10_2']: 'message_poisoning_T2-10-2',

  /* Collection */
  ['T_2_11']: 'collection_T2-11',
  ['T_2_11_1']: 'rag_data_harvesting_T2-11-1',
  ['T_2_11_2']: 'memory_data_hoarding_T2-11-2',
  ['T_2_11_3']: 'user_message_harvesting_T2-11-3',
  ['T_2_11_4']: 'retrieval_tool_data_harvesting_T2-11-4',
  ['T_2_11_5']: 'thread_history_harvesting_T2-11-5',

  /* Command and Control */
  ['T_2_12']: 'command_and_control_T2-12',
  ['T_2_12_1']: 'search_index_c2_T2-12-1',
  ['T_2_12_2']: 'public_web_c2_T2-12-2',

  /* Exfiltration */
  ['T_2_13']: 'exfiltration_T2-13',
  ['T_2_13_1']: 'granular_clickable_link_rendering_T2-13-1',
  ['T_2_13_2']: 'granular_web_request_triggering_T2-13-2',
  ['T_2_13_3']: 'web_request_triggering_T2-13-3',
  ['T_2_13_4']: 'clickable_link_rendering_T2-13-4',
  ['T_2_13_5']: 'write_tool_invocation_T2-13-5',
  ['T_2_13_6']: 'image_rendering_T2-13-6',

  /* Impact */
  ['T_2_14']: 'impact_T2-14',
  ['T_2_14_1']: 'citation_manipulation_T2-14-1',
  ['T_2_14_2']: 'ai_social_engineering_T2-14-2',
  ['T_2_14_3']: 'mutative_tool_invocation_T2-14-3',

  /* MITRE ATLAS Tactics */
  ['TA0001']: 'reconnaissance_AML.TA0001',
  ['TA0002']: 'resource_development_AML.TA0002',
  ['TA0003']: 'initial_access_AML.TA0003',
  ['TA0004']: 'ml_model_access_AML.TA0004',
  ['TA0005']: 'execution_AML.TA0005',
  ['TA0006']: 'persistence_AML.TA0006',
  ['TA0007']: 'privilege_escalation_AML.TA0007',
  ['TA0008']: 'defense_evasion_AML.TA0008',
  ['TA0009']: 'credential_access_AML.TA0009',
  ['TA0010']: 'discovery_AML.TA0010',
  ['TA0011']: 'collection_AML.TA0011',
  ['TA0012']: 'ml_attack_staging_AML.TA0012',
  ['TA0013']: 'exfiltration_AML.TA0013',
  ['TA0014']: 'impact_AML.TA0014',
};
